export enum LocalStorageKeys {
    CookiesConsent
}